import React, {useEffect, useState} from 'react';
import {Col, Container, Row, Button} from "react-bootstrap";
import ScaleLoader from "react-spinners/ScaleLoader";
import {getActiveEnrollments, getTournamentEnrollments} from "../../../services/enrollments";
import {getTournamentRegistrations, getUnconcludedPaidRegistrations, getUnconcludedUnpaidRegistrations} from "../../../services/registrations";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";

// React Components
import Header from '../../../components/Header/Header';
import BulletHeader from '../../../components/BulletHeader/BulletHeader';
import ReplicateCard from "../../../components/ReplicateCard/ReplicateCard";
import RegistrationInfoModal from "../../../components/RegistrationInfoModal";

// CSS Files
import './styles.css';

const override = `
    display: block;
    text-align: center;
    margin-top: 10%;
`;

const EnrollmentsList = () => {
   const [enrollments, setEnrollments] = useState([]);
   const [unconcludedPaidRegistrations, setUnconcludedPaidRegistrations] = useState([]);
   const [unconcludedUnpaidRegistrations, setUnconcludedUnpaidRegistrations] = useState([]);
   const [tournamentEnrollments, setTournamentEnrollments] = useState([]);
   const [tournamentRegistrations, setTournamentRegistrations] = useState([]);
   const [loading, setLoading] = useState(true);
   const [insertRegistrationInfoModal, setInsertRegistrationInfoModal] = useState(false);
   const history = useHistory();
   const { t } = useTranslation();

   useEffect(() => {
      (async () => {
         let enrollments = await getActiveEnrollments();
         let unconcludedPaidRegistrations = await getUnconcludedPaidRegistrations();
         let unconcludedUnpaidRegistrations = await getUnconcludedUnpaidRegistrations();
         let tournamentEnrollments = await getTournamentEnrollments();
         let tournamentRegistrations = await getTournamentRegistrations();

         setEnrollments(enrollments);
         setUnconcludedPaidRegistrations(unconcludedPaidRegistrations);
         setUnconcludedUnpaidRegistrations(unconcludedUnpaidRegistrations);
         setTournamentEnrollments(tournamentEnrollments);
         setTournamentRegistrations(tournamentRegistrations);
         setLoading(false);
      })();
   }, []);

   return (
       <div>
          <Header headerBarTitle={t("registrations_page.header")}/>
          <Container className={"desktop pb-5"}>
             <Row>
                <Col className={"pb-3 pt-3"} xs={12} sm={12}>
                   <p>{t("registrations_page.alert")}</p>
                </Col>
             </Row>

             <div className={"pt-3 pb-3 new-enrollment-background new-enrollment-sticky"}>
                <Button className={"w-100"} variant="primary" onClick={() => history.push('/enrollment/select-event')}>{t("registrations_page.new_registration")}</Button>
             </div>

             <Row>
                <Col xs={12}>
                   <BulletHeader text={t("registrations_page.active_registrations")}/>
                   <ScaleLoader
                       css={override}
                       sizeUnit={"px"}
                       size={30}
                       color={'#afff55'}
                       loading={loading}
                   />
                   {!loading && enrollments.length === 0 && tournamentEnrollments.length === 0 &&
                       <div className="alert alert-info" role="alert">
                          {t("registrations_page.no_registrations")}
                       </div>
                   }
                </Col>

                {!loading && enrollments.map((item, key) => {
                   return <ReplicateCard
                       key={key.toString()}
                       leagueName={item.league + ', ' + item.league_edition}
                       teamPlayers={item.league_division}
                       onClick={() => {
                          history.push('/enrollment/details', {
                             isLeague: true,
                             isRegistration: false,
                             id: item.enrollment_id,
                             league_edition_id: item.league_edition_id
                          });
                       }}/>
                })}

                {!loading && tournamentEnrollments.map((item, key) => {
                   return <ReplicateCard
                       key={key.toString()}
                       leagueName={item.tournament_name + ', ' + item.super_tournament_name}
                       teamPlayers={item.group_name}
                       onClick={() => {
                          history.push('/enrollment/details', {
                             isLeague: false,
                             isRegistration: false,
                             id: item.id,
                             super_tournament_id: item.super_tournament_id
                          })
                       }}/>
                })}

                <Col xs={12}>
                   <BulletHeader
                       showInfoButton
                       text={t("registrations_page.registrations_waiting_matches")}
                       infoButtonOnClick={() => setInsertRegistrationInfoModal(true)}
                   />
                   <ScaleLoader
                       css={override}
                       sizeUnit={"px"}
                       size={30}
                       color={'#afff55'}
                       loading={loading}
                   />
                   {!loading && unconcludedPaidRegistrations.length === 0 &&
                       <div className="alert alert-info" role="alert">
                          {t("registrations_page.no_registrations")}
                       </div>
                   }
                </Col>

                {!loading && unconcludedPaidRegistrations.map((item, key) => {
                   return <ReplicateCard
                       key={key.toString()}
                       leagueName={item.league + ', ' + item.league_edition}
                       teamPlayers={item.league_category}
                       onClick={() => {
                          history.push('/enrollment/details', {
                             isLeague: true,
                             isRegistration: true,
                             id: item.registration_id,
                             league_edition_id: item.league_edition_id
                          });
                       }}/>
                })}

                <Col xs={12}>
                   <BulletHeader text={t("registrations_page.registrations_waiting_payment")}/>
                   <ScaleLoader
                       css={override}
                       sizeUnit={"px"}
                       size={30}
                       color={'#afff55'}
                       loading={loading}
                   />
                   {!loading && unconcludedUnpaidRegistrations.length === 0 &&
                       <div className="alert alert-info" role="alert">
                          {t("registrations_page.no_registrations")}
                       </div>
                   }
                </Col>

                {!loading && unconcludedUnpaidRegistrations.map((item, key) => {
                   return <ReplicateCard
                       key={key.toString()}
                       leagueName={item.league + ', ' + item.league_edition}
                       teamPlayers={item.league_category}
                       onClick={() => {
                          history.push('/enrollment/details', {
                             isLeague: true,
                             isRegistration: true,
                             id: item.registration_id,
                             league_edition_id: item.league_edition_id
                          });
                       }}/>
                })}

                {!loading && tournamentRegistrations.map((item, key) => {
                   return <ReplicateCard
                       key={key.toString()}
                       leagueName={item.tournament_name + ', ' + item.super_tournament_name}
                       onClick={() => {
                          history.push('/enrollment/details', {
                                 isLeague: false,
                                 isRegistration: true,
                                 id: item.id,
                                 super_tournament_id: item.super_tournament_id
                              }
                          )
                       }}/>
                })}
                <RegistrationInfoModal
                    show={insertRegistrationInfoModal}
                    handleShow={() => setInsertRegistrationInfoModal(true)}
                    handleClose={() => setInsertRegistrationInfoModal(false)}
                />
             </Row>
          </Container>
       </div>
   );
}

export default EnrollmentsList;